<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-expansion-panel :focusable="focusable" popout slot-scope="props">
        <v-expansion-panel-content
                :key="i"
                v-for="(item , i) in semesterInfo">

            <div slot="header">
                <v-card class="elevation-1 ma-1"
                        ripple>
                    <v-list :key="i" :style="{background: checkBackgroundColor(item.visibilityFlag)}">
                        <v-list-tile >
                            <v-list-tile-action>
                                <v-checkbox :input-value="item.visibilityFlag" :disabled="util.checkIfBookIsDelivered(item, -1)"
                                            @click.native.stop="onCheckboxChanged(item , i)"
                                            v-if="item.visibilityFlag"/>
                            </v-list-tile-action>
                            <v-list-tile-avatar>
                                <v-icon left>book</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>

                                    <span class="text--primary" v-if="item.courseIno === undefined">
                                        ΧΩΡΙΣ ΤΙΤΛΟ
                                    </span>
                                    <span class="text--primary" v-else>
                                        [{{item.courseIno.code}}] {{item.courseIno.title}}
                                    </span>


                                </v-list-tile-title>
                                <v-list-tile-sub-title class="text-truncate caption">
                                    <span class="text--primary" v-if="item.courseIno === undefined">ΧΩΡΙΣ ΤΙΤΛΟ</span>
                                    <span class='text--primary' v-else>{{item.courseIno.professor}}</span>
                                    <span class="grey--text text--lighten-0" v-if="item.courseIno.period === 'Earino'">&mdash; ΕΑΡΙΝΟ</span>
                                    <span class="grey--text text--lighten-0" v-else-if="item.courseIno.period === 'Ximerino'">&mdash; ΧΕΙΜΕΡΙΝΟ</span>
                                    <span class="grey--text text--lighten-0" v-else-if="item.courseIno.period === 'Etisio'">&mdash; ΕΤΗΣΙΟ</span>
                                    <span class="grey--text text--lighten-0" v-else>ΧΩΡΙΣ ΤΙΤΛΟ</span>
                                    <br/>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card>
            </div>
            <v-container>
                <v-layout align-center justify-start row>
                    <v-flex offset-xs1>
                        <v-list>
                            <div v-if="item.courseBooks.length == 0">
                                <v-card
                                        style="cursor: default"
                                        class="flex"
                                        flat
                                        tile>
                                    <v-card-title class="outline">
                                        <a>Μάθημα χωρίς συγγράμματα</a>
                                    </v-card-title>
                                </v-card>
                            </div>
                            <v-radio-group v-model="item.radioValue">

                                <v-list-tile
                                        avatar
                                        v-for="(bookItem, j) in item.courseBooks">

                                    <v-list-tile-action>
                                        <v-radio class="ml-3"
                                                 :disabled="disabledRadioValue(item, j) || util.checkIfBookIsDelivered(item, j) || util.checkIfStudentHasBookFromPreviousStatements(bookItem.books[0].book)"
                                                 :key="dynamicKey + j"
                                                 :value="bookItem.books[0].book.id"
                                                 @change="onRadioChanged(item, j)"
                                        ></v-radio>
                                    </v-list-tile-action>

                                    <v-list-tile-content>
                                        <v-layout row>

                                            <div v-if="item.courseBooks[j] != []">
                                                <v-card @click="openDialog(bookItem.books[0].book)"
                                                        style="cursor: default"
                                                        class="flex"
                                                        flat
                                                        tile>
                                                    <v-card-title class="outline">
                                                        <v-icon left>library_books</v-icon>
                                                        <a><u>[{{bookItem.books[0].book.id}}] {{bookItem.books[0].book.title}}, {{bookItem.books[0].book.editorialHouse}}</u></a>
                                                    </v-card-title>
                                                </v-card>
                                            </div>

                                            <!--<v-chip @click="openDialog(bookItem.books[0].book)" class="pa-1"-->
                                            <!--color="primary"-->
                                            <!--outline-->
                                            <!--v-if="item.courseBooks[j]">-->
                                            <!--<v-icon left>library_books</v-icon>-->
                                            <!--[{{bookItem.books[0].book.id}}] {{bookItem.books[0].book.title}}, {{bookItem.books[0].book.editorialHouse}}-->
                                            <!--</v-chip>-->
                                            <!--<v-chip @click="openDialog(bookItem.books[0].book)" class="pa-1"-->
                                            <!--color="primary"-->
                                            <!--outline-->
                                            <!--v-else>-->
                                            <!--<v-icon left>library_books</v-icon>-->
                                            <!--[41960176] "Η ΓΛΩΣΣΑ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ C++"Σύγγραμμα-->
                                            <!--</v-chip>-->

                                            <!-----------------------------tooltip for duplicate books---------------------------------------------->

                                            <v-tooltip v-if="disabledRadioValue(item, j)"  bottom>
                                                <template slot="activator" slot-scope="{ on }">
                                                    <v-icon style="cursor: default" class="mb-2 ml-2" color="error" v-on="on">done_all</v-icon>
                                                </template>
                                                <span>Το σύγγραμμα έχει ήδη επιλεγεί στην τρέχουσα δήλωση</span>
                                            </v-tooltip>

                                            <!------------------------------------------------------------------------------------------------------>


                                            <ToolTipComponent class="mt-3" v-if="util.checkToolTipId(bookItem.books[0].book.id)" :bookId="bookItem.books[0].book.id"/>


                                        </v-layout>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-radio-group>
                        </v-list>
                        <div v-if="$store.getters.listLinkedEbooks.hasOwnProperty(item.courseIno.id)">
                        <p><i>Πρόσθετο διδακτικό υλικό (ηλεκτρονική μορφή)</i></p>
                        </div>
                        <v-flex v-if="item.courseIno !== undefined">
                            <v-list>
                                <v-list-tile :key="j"
                                             :value="j"
                                             avatar
                                             v-for="(ebook, j) in $store.getters.listLinkedEbooks[item.courseIno.id]">

                                    <v-list-tile-content>
                                        <v-card @click="ebookDisplay(ebook)"
                                                style="cursor: default"
                                                class="flex"
                                                flat
                                                tile>
                                            <v-card-title class="outline">
                                                <v-icon left>picture_as_pdf</v-icon>
                                                <a href="#">{{ebook.title}}</a>
                                            </v-card-title>
                                        </v-card>
                                        <!--<v-chip @click="ebookDisplay(ebook.linkToPublisher)" class="pa-1"-->
                                                <!--color="secondary"-->
                                                <!--outline>-->
                                            <!--<v-icon left>picture_as_pdf</v-icon>-->
                                            <!--{{ebook.title}}-->
                                        <!--</v-chip>-->
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>

    import util from "../../utilities"
    import ToolTipComponent from "../ExtraComponents/ToolTipComponent";
    import {EventBus} from "../../utilities"
    import requests from "../../requests";


    export default {
        components: {ToolTipComponent},
        data() {
            return {
                itemObject: {},
                util,
                CONST_TRUE: true,
                focusable: false
            }
        },
        props: {
            semesterInfo: Array,
            semester: Number,
            dynamicKey:Number
        },
        methods: {
            disabledRadioValue(item, j) {

                var checkedBooks = this.$store.getters.checkedBooks;

                if (this.itemObject.hasOwnProperty('books')){
                    if (this.itemObject.books[0].book.id == item.courseBooks[j].books[0].book.id) {
                        return true
                    }
                }
                else {
                    for (var courseId in checkedBooks) {
                        if (checkedBooks[courseId].books.books[0].book.id == item.courseBooks[j].books[0].book.id &&
                            courseId != item.courseBooks[j].courseId) {
                            return true;
                        }
                    }
                    return false
                }

            },
            onRadioChanged(item, j) {
                EventBus.$emit('testComponent', item.courseBooks[j]);
                if (!item.visibilityFlag) {
                    item.visibilityFlag = !item.visibilityFlag;
                }
                this.addToArray(item, j)
            },
            addToArray(item, j) {
                this.$emit('addToArray', {item: item, j: j})
            },
            removeToArray(item) {
                this.$emit('removeToArray', {item: item})
            },
            onCheckboxChanged(item, j) {
                var itemObject = {item:null};
                EventBus.$emit('testComponent', itemObject);
                item.visibilityFlag = false;
                item.radioValue = null;
                this.removeToArray(item, j);
            },
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },
	        ebookDisplay(item) {
		        if(item.type === 'ProfessorNotes'){
			        requests.putForFilesWithRetryIfNotSuccess('student/api/books/get-book-pdf', item, (errorMessage)=> {
				        if (errorMessage === '{error} Το αρχείο δεν βρέθηκε.') {
					        window.open(item.linkToPublisher, "_blank");
				        } else {
					        var storeObj = {
						        title: 'Σφάλμα!',
						        text: errorMessage,
						        color: 'indianRed',
						        class: 'white--text indianRed text-center justify-center'
					        };

					        this.$store.commit('setErrorPopup', true);
					        this.$store.commit('setErrorPopupProps', storeObj);
					        this.$store.commit('setLoadingModal', false);
				        }
			        });
		        } else if(item.type === 'eBook'){
			        window.open(item.linkToPublisher, "_blank");
		        }
            },
            checkBackgroundColor(visibilityFlag){
                if (visibilityFlag){
                    return '#E0E0E0'
                }

            }
        },
        created() {
            EventBus.$on('linkedCheck', itemObject => {
                this.itemObject = itemObject;
            });
        }
    }
</script>

<style scoped>

</style>
